export const common = {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Product Resources, Sellers & Buying Guides',
  explore: 'Explore AllChinaBuy Spreadsheet',
  browseGuides: 'Browse Buying Guides',
  buyItNow: 'Buy It Now',
  allchinabuySpreadsheet: 'AllChinaBuy Spreadsheet',
  visitMainSite: 'Visit Main Store',
  searchPlaceholder: 'Search AllChinaBuy products, sellers, shipping or guides...',
  categories: 'Categories',
  articles: 'Articles',
  guides: 'Guides',
  reviews: 'Reviews',
  shipping: 'Shipping',
  coupon: 'Coupon',
  warehouse: 'Warehouse',
  legit: 'Is It Legit?',
  about: 'About',
  contact: 'Contact',
  faq: 'FAQ',
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  disclaimer: 'Disclaimer',
  home: 'Home',
  readMore: 'Read More',
  relatedArticles: 'Related Articles',
  tableOfContents: 'Table of Contents',
  lastUpdated: 'Last Updated',
  author: 'Author',
  share: 'Share',
  question: 'Have a Question?',
  ctaMainTitle: 'Ready to Shop?',
  ctaMainDesc: 'Visit our main store for the full AllChinaBuy product catalog.',
  ctaMainButton: 'Go to Main Store',
  footerDesc: 'AllChinaBuy Spreadsheet is your organized resource for AllChinaBuy products, sellers, shipping guides, and buying tips.',
  copyright: 'All rights reserved.',
  notAffiliated: 'Not affiliated with AllChinaBuy. Informational resource only.',
  language: 'Language',
  english: 'English',
  french: 'French',
  german: 'German',
  danish: 'Danish',
  breadcrumbHome: 'Home',
  minutesRead: 'min read',
  quickLinks: 'Quick Links',
  resources: 'Resources',
  legal: 'Legal',
  scrollToTop: 'Scroll to top',
  viewAll: 'View All',
  allProducts: 'All Products',
  buyNow: 'Buy Now',
  productsPageTitle: 'AllChinaBuy Products — Browse Shoes, Clothing, Accessories & More',
  productsPageDescription: 'Browse 100+ verified products from AllChinaBuy spreadsheet. Shoes, hoodies, t-shirts, jackets, accessories, bags, perfumes and more with direct purchase links.',
  pageNotFound: 'Page Not Found',
  pageNotFoundDesc: 'The page you are looking for does not exist.',
  featuredProducts: 'Featured Products',
  featuredProductsDesc: 'Handpicked items from our AllChinaBuy catalog',
  viewAllProducts: 'View All Products',
};

export const nav = {
  home: 'Home',
  products: 'Products',
  categories: 'Categories',
  articles: 'Articles',
  reviews: 'Reviews',
  shipping: 'Shipping',
  coupon: 'Coupon',
  warehouse: 'Warehouse',
  legit: 'Legit?',
  about: 'About',
};

export const hero = {
  h1: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Resources Faster',
  subtitle: 'Explore AllChinaBuy spreadsheet resources, products, sellers, QC information, shipping guides, reviews and buying tips in one organized place.',
  ctaPrimary: 'Explore AllChinaBuy Spreadsheet',
  ctaSecondary: 'Browse Buying Guides',
  searchPlaceholder: 'Search AllChinaBuy products, sellers, shipping or guides...',
};

export const categories = {
  title: 'Popular AllChinaBuy Categories',
  subtitle: 'Browse the most popular product categories on AllChinaBuy',
  shoes: 'Shoes',
  hoodiesSweaters: 'Hoodies & Sweaters',
  tshirts: 'T-Shirts',
  jackets: 'Jackets',
  pantsShorts: 'Pants & Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear & Underpants',
  jersey: 'Jersey',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  otherStuff: 'Other Stuff',
  viewAll: 'View All Categories',
};

export const homeSections = {
  popularSearchesTitle: 'Popular AllChinaBuy Searches',
  popularSearchesDesc: 'Discover what buyers are looking for right now',
  spreadsheetHubTitle: 'AllChinaBuy Spreadsheet Hub',
  spreadsheetHubDesc: 'Your complete resource for organized product and seller information',
  resourcesTitle: 'Product & Seller Resources',
  resourcesDesc: 'Comprehensive guides to help you navigate AllChinaBuy',
  reviewTitle: 'AllChinaBuy Review',
  reviewDesc: 'Honest, in-depth reviews from real buyers and our editorial team',
  shippingTitle: 'AllChinaBuy Shipping Cost',
  shippingDesc: 'Compare shipping methods, lines, times, and costs for your region',
  couponTitle: 'Coupon & Discount Code',
  couponDesc: 'Latest verified coupons, promo codes, and deals for AllChinaBuy',
  warehouseTitle: 'Warehouse Guide',
  warehouseDesc: 'Understand how AllChinaBuy warehouses work and optimize your storage',
  legitTitle: 'Is AllChinaBuy Legit?',
  legitDesc: 'Safety guide, trust analysis, and scam awareness for AllChinaBuy buyers',
  comparisonTitle: 'Comparison Tables',
  comparisonDesc: 'See how AllChinaBuy stacks up against other buying agents',
  articlesTitle: 'Latest Articles',
  articlesDesc: 'Fresh guides, tips, and insights for AllChinaBuy buyers',
  faqTitle: 'Frequently Asked Questions',
  faqDesc: 'Quick answers to common AllChinaBuy questions',
  finalCtaTitle: 'Start Your AllChinaBuy Journey',
  finalCtaDesc: 'Visit our main store for the full catalog and latest deals.',
  finalCtaButton: 'Visit Main Store',
};

export const articles = {
  allchinabuySpreadsheetGuide: 'AllChinaBuy Spreadsheet Guide: Complete Product & Seller Directory 2026',
  allchinabuySpreadsheetGuideDesc: 'The most comprehensive guide to using AllChinaBuy spreadsheets. Learn how to find products, sellers, QC photos, and shipping info faster.',
  allchinabuyReview2026: 'AllChinaBuy Review 2026: Features, Shipping & Buying Guide',
  allchinabuyReview2026Desc: 'An honest review of AllChinaBuy features, pros, cons, shipping, and buying experience. Updated for 2026.',
  allchinabuyShippingCost: 'AllChinaBuy Shipping Cost: Complete Guide & Comparison',
  allchinabuyShippingCostDesc: 'Compare shipping lines, costs, delivery times, and customs tips for AllChinaBuy orders.',
  allchinabuyCoupon: 'AllChinaBuy Coupon & Discount Code: Latest Deals Guide',
  allchinabuyCouponDesc: 'Find the latest verified AllChinaBuy coupons, discount codes, and promotional deals.',
  allchinabuyWarehouseGuide: 'AllChinaBuy Warehouse Guide: Storage, QC & Shipping',
  allchinabuyWarehouseGuideDesc: 'Everything you need to know about AllChinaBuy warehouses, storage, and quality control.',
  isAllchinabuyLegit: 'Is AllChinaBuy Legit? Safety & Trust Guide 2026',
  isAllchinabuyLegitDesc: 'Safety analysis, trust indicators, scam awareness, and tips for buying securely on AllChinaBuy.',
  allchinabuyVsSuperbuy: 'AllChinaBuy vs Superbuy: Detailed Comparison 2026',
  allchinabuyVsSuperbuyDesc: 'Side-by-side comparison of AllChinaBuy and Superbuy features, shipping, QC, and pricing.',
  allchinabuyBeginnerGuide: 'AllChinaBuy Beginner Guide: How to Buy Step by Step',
  allchinabuyBeginnerGuideDesc: 'New to AllChinaBuy? This step-by-step guide walks you through registration, browsing, buying, and shipping.',
};

export const articleContent = {
  spreadsheetGuideTitle: 'AllChinaBuy Spreadsheet Guide: Complete Product & Seller Directory 2026',
  spreadsheetGuideIntro: 'AllChinaBuy has become one of the most popular buying agents for international shoppers looking to source products from Chinese marketplaces. Whether you are hunting for sneakers, streetwear, accessories, or niche finds, the AllChinaBuy spreadsheet ecosystem helps you organize product links, seller information, QC photos, and pricing in one place. This guide is the most complete resource for understanding how to use AllChinaBuy spreadsheets to shop smarter, save money, and avoid common mistakes.',
  whatIsSpreadsheetTitle: 'What Is an AllChinaBuy Spreadsheet?',
  whatIsSpreadsheetContent: 'An AllChinaBuy spreadsheet is a curated document or database that contains organized links to products, sellers, and buying resources on AllChinaBuy. These spreadsheets can include categories like shoes, clothing, accessories, bags, and more. They often contain product names, seller names, prices, QC (quality control) photo links, size charts, and direct purchase links. The goal is to save buyers time by providing a structured way to browse and compare products without manually searching through marketplaces.',
  whyUseSpreadsheetTitle: 'Why Use AllChinaBuy Spreadsheets?',
  whyUseSpreadsheetContent1: 'Save time — Instead of browsing aimlessly, spreadsheets give you direct links to curated products and trusted sellers.',
  whyUseSpreadsheetContent2: 'Compare prices — See prices for similar products across different sellers in one view.',
  whyUseSpreadsheetContent3: 'QC photos — Many spreadsheets include links to quality control photos so you know exactly what you are getting.',
  whyUseSpreadsheetContent4: 'Trusted sellers — Curated spreadsheets often highlight sellers with good reviews and reliable service.',
  whyUseSpreadsheetContent5: 'Community-driven — The best spreadsheets are maintained by communities of buyers who share finds and update listings regularly.',
  howToUseSpreadsheetTitle: 'How to Use an AllChinaBuy Spreadsheet',
  howToUseSpreadsheetContent: 'Using an AllChinaBuy spreadsheet is straightforward. First, identify the category you are interested in — such as shoes, hoodies, or accessories. Open the spreadsheet and browse the relevant tab or section. Each row typically contains the product name, seller, price, and a link. Click the link to view the product on the marketplace or AllChinaBuy platform. Before purchasing, check if there are QC photos available and read any notes from the spreadsheet curator. Add the product to your AllChinaBuy cart, submit the purchase, and wait for the item to arrive at the warehouse. Once it arrives, review the QC photos and either approve or request a return.',
  popularCategoriesTitle: 'Popular AllChinaBuy Spreadsheet Categories',
  popularCategoriesContent: 'The most popular categories in AllChinaBuy spreadsheets include shoes and sneakers, hoodies and sweaters, t-shirts, jackets, pants and shorts, headwear, accessories, bags, belts, and perfumes. Each category has its own set of trusted sellers and product ranges. For example, shoes spreadsheets often include reps and authentic finds from popular brands, while accessories spreadsheets cover watches, jewelry, phone cases, and more. Clothing spreadsheets are the most diverse, covering everything from streetwear to formal wear.',
  spreadsheetTipsTitle: 'Tips for Getting the Most Out of Spreadsheets',
  spreadsheetTipsContent1: 'Always verify seller reputation before purchasing — check reviews and recent feedback.',
  spreadsheetTipsContent2: 'Compare prices across multiple spreadsheets — different curators may have different deals.',
  spreadsheetTipsContent3: 'Join communities — Discord servers, Reddit forums, and Telegram groups often share the most up-to-date spreadsheets.',
  spreadsheetTipsContent4: 'Check QC photos carefully — what you see in the spreadsheet may differ slightly from the final product.',
  spreadsheetTipsContent5: 'Save your favorite spreadsheets — bookmark them so you can check back for updates and new finds.',
  comparisonTitle: 'AllChinaBuy vs Other Buying Agents',
  comparisonContent: 'When comparing AllChinaBuy to other buying agents like Superbuy, CSSBuy, Sugargoo, and Basetao, each platform has its strengths. AllChinaBuy tends to be popular for its spreadsheet-friendly approach and community sharing. Superbuy offers more polished software and customer support. CSSBuy is known for competitive shipping rates. Sugargoo has a user-friendly interface. Basetao offers older but reliable service. For spreadsheet users, AllChinaBuy is often preferred because its community actively shares and maintains product lists.',
  faqQuestion1: 'Are AllChinaBuy spreadsheets free to use?',
  faqAnswer1: 'Yes, most AllChinaBuy spreadsheets are free and shared by community members. Some curators may offer premium spreadsheets with exclusive finds for a small fee.',
  faqQuestion2: 'How often are spreadsheets updated?',
  faqAnswer2: 'It depends on the curator. Active community spreadsheets are updated weekly or monthly. Less active ones may be outdated. Always check the last update date.',
  faqQuestion3: 'Can I trust all sellers in a spreadsheet?',
  faqAnswer3: 'Not all sellers are equally reliable. Reputable spreadsheets usually include notes about seller quality. Always verify by checking recent reviews and QC photos.',
  faqQuestion4: 'What should I do if a product link is broken?',
  faqAnswer4: 'If a product link is broken, try searching for the product name or seller on the marketplace directly. You can also ask the spreadsheet curator or community for an updated link.',
  conclusionTitle: 'Conclusion',
  conclusionContent: 'AllChinaBuy spreadsheets are an invaluable tool for international buyers who want to save time, compare products, and buy with confidence. By using curated spreadsheets, you can access trusted sellers, QC photos, and organized product categories in one place. Whether you are a beginner or experienced buyer, this guide gives you everything you need to start using AllChinaBuy spreadsheets effectively in 2026.',
  backToHome: 'Back to Home',
  nextArticle: 'Next Article',
  prevArticle: 'Previous Article',
  writtenBy: 'Written by',
  publishedOn: 'Published on',
  updatedOn: 'Updated on',
  readingTime: 'Reading time',
};

export default {
  ...common,
  ...nav,
  ...hero,
  ...categories,
  ...homeSections,
  ...articles,
  ...articleContent,
};